export const API_BASE_URL = 'https://api.one-marts.com/api';
export const UPLOAD_URL = 'https://api.one-marts.com/'
 
